import { hashKey, useQuery, type QueryClient } from '@tanstack/react-query'
import type { FrontendBootstrap } from '@/shared/types/api'

type BootstrapLoader = () => Promise<FrontendBootstrap>
let loadBootstrap: BootstrapLoader = () => Promise.reject(new Error('Session bootstrap is not configured.'))

/** The application owns navigation links and the authentication transport. */
export function configureBootstrapLoader(loader: BootstrapLoader) {
  loadBootstrap = loader
}

export const bootstrapQueryKey = ['frontend', 'bootstrap'] as const

export function fetchBootstrap() {
  return loadBootstrap()
}

export function useBootstrap() {
  return useQuery({ queryKey: bootstrapQueryKey, queryFn: fetchBootstrap, staleTime: Number.POSITIVE_INFINITY })
}

/** Account changes must evict data whose keys are not scoped by account. */
export function clearAccountQueries(queryClient: QueryClient) {
  const bootstrapHash = hashKey(bootstrapQueryKey)
  queryClient.removeQueries({ predicate: (query) => query.queryHash !== bootstrapHash })
}
